import { IconButton, Tooltip } from "@mui/material";
//import  "../../../../css/Purchase Manager/StockAdjustment/requestForQuatationNw.css"
import React, { useRef } from "react";
import postRibbon from "../../../../../Assets/statusRibbon/post.png";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useState } from "react";
import { useEffect } from "react";
import Draft from "../../../../../Assets/statusRibbon/draft.png";
import Done from "../../../../../Assets/statusRibbon/done.png";
import Sales from "../../../../../Assets/statusRibbon/salesOrder.png";
// Direct print without react-to-print
import { convertDateFormat, today } from "../../../../../Js/Date";
import { getTemplateAPI } from "../SalesQuotation/salesQuatationAPI";
import { salesOrderSingleViewAPICall } from "./salesOrderAPI";
import { set_Back_button_action } from "../../../../Single Components/listSlice/filterCategorySlice";
import ExcelJS from "exceljs";
export const SalesOrderSingleView = () => {
  const printRef = useRef(null);

  const singleRowId = localStorage.getItem("singleViewById");
  const decimalPosition = localStorage.getItem("decimalPosition");
  //data of selected List
  const singleList = useSelector((state) => state?.salesOrderSlice?.rowData);
  // company details and info
  const companyProfileData =useSelector(
    (state) => state?.companyProfileSlice?.userValue)
  const template =useSelector((state)=>state?.salesQuatationSlice?.setTemplate)

  // initial values
  const dispatch = useDispatch();
  const formValuesInitialState = {
    status: "",
    companyLogo: "",
    companyName: "",
    companyAddress: "",
    companyContact: "",
    companyTRN: "",


    customerName: "",
    customerAddress: "",
    customerContact: "",
    trn:"",

    deliveryName: "",
    deliveryAddress: "",
    deliveryContact: "",

    dateN1:"Return Date",
    dateN2:"Invoice Date",

    termsAndCondition:"",

    lpo:"",
    name: "",
    firstDate: "",
    secondDate: "",
    ref:"",
    subtotal: "",
    inclusiveTax: "",
    exclusiveTax: "",
    total: "",
    totalAmount:"",
    payTerm:"",
    sequence:"Order No",
    label:"SALES ORDER"
  };
  const [formValues, setFormValues] = useState(formValuesInitialState);

  // table values
  const [tax, setTax] = useState([]);
  const [data, setData] = useState([]);

    const downloadList = () => {
    const workbook = new ExcelJS.Workbook();
    const sheet = workbook.addWorksheet("Sales Order");
    
    // Set default styles
    sheet.properties.defaultRowHeight = 20;
    
    // Header Section
    const headerRow = sheet.addRow(["Sales Order"]);
    headerRow.font = { size: 16, bold: true };
    headerRow.height = 25;
    sheet.mergeCells("A1:K1");
    headerRow.getCell(1).alignment = { vertical: "middle", horizontal: "center" };
    
    // Company Information
    sheet.addRow([`Company: ${formValues.companyName}`]);
    sheet.addRow([`Address: ${formValues.companyAddress}`]);
    sheet.addRow([`Contact: ${formValues.companyContact}`]);
    // Customer Information
    const customerHeaderRow = sheet.addRow(["Customer Address:"]);
    customerHeaderRow.font = { bold: true };
    sheet.addRow([`Name: ${formValues.customerName}`]);
    sheet.addRow([`Address: ${formValues.customerAddress}`]);
    sheet.addRow([`Contact: ${formValues.customerContact}`]);
    sheet.addRow([`Quotation Number: ${formValues.name}`]);
    sheet.addRow([`Quotation Date: ${formValues.firstDate}`]);
    sheet.addRow([`Expiry Date: ${formValues.secondDate}`]);
    // Table Header
    const tableHeaderRow = sheet.addRow([
      "SI No", "Product", "Description", "Qty", "UOM", 
      "Rate", "Amount", "Disc%", "VAT%", "VAT", "Net Amount"
    ]);
    
    // Style for table header
    const headerFill = {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: "FFEAEEF9" },
    };
    
    const headerFont = {
      size: 12,
      bold: true,
      color: { argb: "FF000000" },
    };
    
    tableHeaderRow.eachCell((cell, colNumber) => {
      cell.fill = headerFill;
      cell.font = headerFont;
      cell.alignment = { vertical: "middle", horizontal: "center" };
      // cell.border = {
      //   top: { style: "thin" },
      //   left: { style: "thin" },
      //   bottom: { style: "thin" },
      //   right: { style: "thin" }
      // };
    });
    
    // Table Data
    data?.forEach((item, index) => {
      const row = sheet.addRow([
        index + 1,
        item.product || '', 
        item?.label || '', 
        item.qty || 0, 
        item.uomName || '', 
        item.unitPrice?.toFixed(decimalPosition) || 0, 
        (item.qty * item.unitPrice)?.toFixed(decimalPosition) || 0, 
        item.discount || 0, 
        item.taxIdList?.map(r => r?.taxName).join(', ') || '', 
        item.taxAmt?.toFixed(decimalPosition) || 0, 
        item.includedPrice === false 
          ? (item.lineTotal + item.taxAmt)?.toFixed(decimalPosition) 
          : item.lineTotal?.toFixed(decimalPosition) 
      ]);
      
      // Alternate row coloring
      const rowFill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: index % 2 === 0 ? "FFF1F2F5" : "FFFFFFFF" },
      };
      
      row.eachCell((cell) => {
        cell.fill = rowFill;
        // cell.border = {
        //   top: { style: "thin" },
        //   left: { style: "thin" },
        //   bottom: { style: "thin" },
        //   right: { style: "thin" }
        // };
        cell.alignment = { horizontal: "center" };
      });
    });
    
    // Table Footer (Totals)
    const totalRow = sheet.addRow([
      "TOTAL", "", "", "", "", "", 
      data?.reduce((total, item) => {
        const qty = typeof item.qty === "number" ? item.qty : 0;
        const unitPrice = typeof item.unitPrice === "number" ? item.unitPrice : 0;
        return total + qty * unitPrice;
      }, 0)?.toFixed(decimalPosition) || 0, 
      "", 
      "", 
      data?.reduce((acc, row) => acc + row?.taxAmt, 0.0)?.toFixed(decimalPosition) || 0,
      data?.reduce((acc, row) => {
        if (row.includedPrice === false) {
          return acc + (row.lineTotal + row.taxAmt);
        } else {
          return acc + row.lineTotal;
        }
      }, 0.0)?.toFixed(decimalPosition) || 0 
    ]);
    
    // Style for total row
    const totalFill = {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: "FFE9E9E9" },
    };
    
    totalRow.eachCell((cell) => {
      cell.fill = totalFill;
      cell.font = { bold: true };
      cell.alignment = { horizontal: "center" };
      // cell.border = {
      //   top: { style: "thin" },
      //   left: { style: "thin" },
      //   bottom: { style: "thin" },
      //   right: { style: "thin" }
      // };
    });
    
    // Summary Section
    const summaryRows = [
      ["", "", "", "", "", "", "", "", "", "Sub Total", formValues?.subtotal || 0],
      ["", "", "", "", "", "", "", "", "", "Total Tax Inclusive", formValues?.inclusiveTax || 0],
      ["", "", "", "", "", "", "", "", "", "Total Tax Exclusive", formValues?.exclusiveTax || 0],
      ["", "", "", "", "", "", "", "", "", "Total", formValues?.total || 0]
    ];
    
    summaryRows.forEach(row => {
      const excelRow = sheet.addRow(row);
      
      const labelCell = excelRow.getCell(10);
      labelCell.font = { bold: true };
      labelCell.alignment = { horizontal: "right" };
      
      const valueCell = excelRow.getCell(11);
      valueCell.numFmt = '#,##0.00';
      valueCell.alignment = { horizontal: "right" };
       excelRow.eachCell((cell) => {
        cell.fill = headerFill;
      });
    });
    
    
    // Auto-size columns
    sheet.columns.forEach(column => {
      let maxLength = 0;
      column.eachCell({ includeEmpty: true }, cell => {
        const columnLength = cell.value ? cell.value.toString().length : 0;
        if (columnLength > maxLength) {
          maxLength = columnLength;
        }
      });
      column.width = Math.min(Math.max(maxLength + 2, 10), 30);
    });
    
    // Generate and download the Excel file
    workbook.xlsx.writeBuffer().then(function(data) {
      const blob = new Blob([data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const url = window.URL.createObjectURL(blob);
      const anchor = document.createElement("a");
      anchor.href = url;
      anchor.download = `Sales_Order_${formValues.name || 'salesOrder'}.xlsx`;
      anchor.click();
      window.URL.revokeObjectURL(url);
    });
  };

  // Direct print function - bypasses react-to-print
  const handlePrint = () => {
    const printContent = printRef.current;
    if (!printContent) {
      alert('Print content not ready');
      return;
    }
    
    const printWindow = window.open('', '_blank');
    printWindow.document.write(`
      <html>
        <head>
          <title>Sales Order - ${formValues?.name || 'SalesOrder'}</title>
          <style>
            @page { size: A4; margin: 10mm; }
            body { font-family: Arial, sans-serif; margin: 0; padding: 20px; }
            table { width: 100%; border-collapse: collapse; }
            th, td { padding: 8px; border: 1px solid #ddd; }
            th { background-color: #333; color: white; }
            @media print {
              body { -webkit-print-color-adjust: exact; print-color-adjust: exact; }
            }
          </style>
        </head>
        <body>${printContent.innerHTML}</body>
      </html>
    `);
    printWindow.document.close();
    printWindow.focus();
    setTimeout(() => {
      printWindow.print();
      printWindow.close();
    }, 250);
  };

  // api to fetch companyprofile data

  useEffect(() => {
    getTemplateAPI();
    if (singleRowId) {
      salesOrderSingleViewAPICall({ _id: singleRowId });
    }
  }, []);
  useEffect(() => {
    setFormValues({
      ...formValues,
      status: singleList?.status,
      companyLogo: companyProfileData?.logo || "",
      companyName: companyProfileData?.companyName || "",
      companyAddress: companyProfileData?.companyAddress || "",
      companyContact: companyProfileData?.contactNumber || "",
      companyTRN: companyProfileData?.companyTRN || "",

      customerName: singleList?.customerAddress?.customerName || "",
      customerAddress: singleList?.customerAddress?.streetName || "",
      customerContact: singleList?.customerAddress?.mobileNo || "",
      trn: singleList?.customerAddress?.TRN || "",

      // deliveryName: singleList?.supplierName || "",
      // deliveryAddress: singleList?.status || "",
      // deliveryContact: singleList?.status || "",
      termsAndCondition:singleList?.termsAndConditions || "",


      lpo: singleList?.LpoNo ||"",
      name: singleList?.NAME || "",
      firstDate: singleList?.quotationDate || "",
      secondDate: singleList?.expiryDate || "",
      ref: singleList?.reference || "",
      subtotal: singleList?.subTotal || "",
      inclusiveTax: singleList?.totalTaxInclusive || "",
      exclusiveTax: singleList?.totalTaxExclusive || "",
      totalAmount: singleList?.totalAmount || "",
      total: singleList?.total || "",
      payTerm: singleList?.PAYMENTTERM || "",
      qrcodetype: singleList?.qrcodetype || "",
      customerId: singleList?.customerId || "",
      db: singleList?.db || "",
      _id: singleList?._id || "",
    });
    setTax(singleList?.taxDetails)
    setData(singleList?.productInfo);
  }, [singleList, companyProfileData]);

  let navigateTo = useNavigate();
  const [domain, setDomain] = useState("");
  useEffect(() => {
    if (formValues) {
      let element = formValues;
      const domainAddress = `${window.location.protocol}//${window.location.host}/posReaderPreview?path=admin/viewqrcodedata&db=${encodeURIComponent(element?.db)}&vendororcusid=${encodeURIComponent(element?.customerId)}&type=${encodeURIComponent(element?.qrcodetype)}&orderId=${encodeURIComponent(element?._id)}`;
      setDomain(domainAddress);
    }
  }, [formValues]);
  return (
    <div className="main-container" style={{ backgroundColor: "unset", padding: "0" }}>
      <div className="first-div-container"style={{ backgroundColor: "white", justifyContent: "space-between" }}>
        {/* <div className="post-ribbon">
          {formValues?.status === "DRAFT" && <img src={Draft} alt="" />}
          {formValues?.status === "POSTED" && <img src={postRibbon} alt="" />}
          {formValues?.status === "DONE" && <img src={Done} alt="" />}
          {formValues?.status === "SALES ORDER" && <img src={Sales} alt="" />}
        </div> */}
        <div style={{display:"flex",gap:"8px"}}>
          {singleList?.status !== 'DONE' ? (
            <Tooltip title="Edit">
              <IconButton>
                <i
                  class="bi bi-pencil-square edit-icon1"
                  onClick={() =>
                    navigateTo("/userdashboard/sales/orders/salesOrder/create")
                  }
                >
                </i>
              </IconButton>
            </Tooltip>
          ) : (
            <div></div>
          )}
        
          <h3>
            <span
              
              style={{ fontSize: "medium", color: "black", cursor: "pointer" }}
              onClick={() =>
               { navigateTo("/userdashboard/sales/orders/salesOrder")
               dispatch(set_Back_button_action({ backButtonClickAction: true }));
              }
              }
            > Sales Order &gt;</span>
         <span style={{fontSize:"medium",paddingLeft:"8px"}}>{formValues?.name}</span>

          </h3>
        
        </div>
        {/* <ReactToPrint
          trigger={() => (
            <IconButton className="printer-div">
              <i style={{ color: "black" }} class="bi bi-printer"></i>
            </IconButton>
          )}
          content={() => paymentsPrint}
        /> */}
        <div>
        <Tooltip  title="Share">
          <IconButton>
            <i class="bi bi-share" style={{ backgroundColor: "#9797e9", color: "white", fontSize: "medium", padding: "8px", borderRadius: "2px" }}></i>
          </IconButton>
        </Tooltip>

        <Tooltip title="Print">
          <IconButton onClick={handlePrint} className="printer-div" style={{ padding: "1px" }}>
            <i
              style={{
                color: "white",
                backgroundColor: "#d787e7",
                fontSize: "medium",
                padding: "8px",
                borderRadius: "2px",
              }}
              className="bi bi-printer"
            ></i>
          </IconButton>
        </Tooltip>

        <Tooltip title="Download">
          <IconButton  onClick={downloadList}>
            <i class="bi bi-arrow-down-circle" style={{ backgroundColor: "rgb(255 118 133 / 69%)", color: "white", fontSize: "medium", padding: "8px", borderRadius: "2px" }}></i>
          </IconButton>
        </Tooltip>
        </div>
      </div>
      {/* <hr className="line" /> */}
      <div style={{ backgroundColor: "white", height: "84vh", marginTop: "4px", position: "relative" }}>

      <div className="second-main-container">
      <div className="post-ribbon" style={{ right: "0px", top: "0px" }}>
          {formValues?.status === "DRAFT" && <img src={Draft} alt="" />}
          {formValues?.status === "POSTED" && <img src={postRibbon} alt="" />}
          {formValues?.status === "DONE" && <img src={Done} alt="" />}
          {formValues?.status === "SALES ORDER" && <img src={Sales} alt="" />}
        </div>
        <div className="left-side-div">
          <img src={formValues?.companyLogo} alt="" />
         <p>{formValues?.companyName}</p>
          <p>{formValues?.companyAddress}</p>
          <p>{formValues?.companyContact}</p>

          <h1 className="vendor-head">Customer Address</h1>
          <p>{formValues?.customerName}</p>
          <p>{formValues?.customerContact}</p>        

          <h1 className="vendor-head">Delivery To </h1>
          {/* <p>--</p>
          <p>--</p>
          <p>--</p> */}
        </div>
        <div className="right-side-div">
          <h1>Sales Order</h1>
          <p>{formValues?.name}</p>
          <div className="date-div">
            <p>
              <span class="date-container-single">Quotation Date:</span>
              {formValues?.firstDate}
            </p>
            <p>
              <span class="date-container-single">Expiry Date:</span>
              {formValues?.secondDate}
            </p>
          </div>
        </div>
      </div>

      <div className="Table-container">
        <div className="Table-data" style={{maxHeight:"45vh"}}>
          <table>
            <thead>
              <tr style={{ backgroundColor: "#eaeef9" }}>
              <th>SI NO</th>
                <th>PRODUCT</th>
                <th>DESCRIPTION</th>
                <th>QTY</th>
                <th>UOM</th>
                <th>RATE</th>
                <th>AMOUNT</th>
                <th>DISC%</th>
                <th>VAT% </th>
                <th>VAT</th>
                <th>NET AMOUNT</th>
              </tr>
            </thead>
            <tbody>
              {data?.map((item, index) => (
                <tr
                  key={index}
                  style={{
                    backgroundColor: index % 2 === 0 ? "#f1f2f5" : "white",
                  }}
                >
                 <td>{index + 1}</td>
                  <td>{item.product}</td>
                  <td>{item?.label}</td>
                  <td>{item.qty}</td>
                  <td>{item.uomName}</td>
                  <td>{item.unitPrice?.toFixed(decimalPosition)}</td>
                  <td>{(item.qty * item.unitPrice)?.toFixed(decimalPosition)}</td>
                  <td>{item.discount}%</td>
                  <td

                  >
                    {item.taxIdList?.map((r, i) => (
                      <p key={i} className="tax" style={{ margin: "1px", border: "none" }}>
                        {r?.taxName}
                      </p>
                    ))}
                  </td>
                  <td>{item.taxAmt?.toFixed(decimalPosition)}</td>
                  <td>
                    {item.includedPrice === false ?
                      ((item.lineTotal + item.taxAmt)?.toFixed(decimalPosition)) :
                      (item.lineTotal?.toFixed(decimalPosition))
                    }
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          
        </div>
        <div style={{ backgroundColor: "#e9e9e9", display: "flex", textAlign: "end", paddingInline: "5%",width:"85%" }}>
            <p style={{ margin: "0" }}>Total</p>
            {data && data.length > 0 && (
              <p style={{ width: "58%", margin: "0" }}>
                {" "}
                {data?.reduce((total, item) => {
                  const qty = typeof item.qty === 'number' ? item.qty : 0; // Check if item.qty is a number, otherwise default to 0
                  const unitPrice = typeof item.unitPrice === 'number' ? item.unitPrice : 0; // Check if item.unitPrice is a number, otherwise default to 0
                  return total + qty * unitPrice;
                }, 0)?.toFixed(decimalPosition)}
              </p>
            )}


            <p style={{ width: "27%", margin: "0" }}> {(data?.reduce((acc, row) => acc + row?.taxAmt, 0.00))?.toFixed(decimalPosition)}</p>
            <p style={{ width: "14%", padding: "3px", margin: "0", fontSize: "smaller" }}>
              {data?.reduce((acc, row) => {
                if (row.includedPrice === false) {
                  return acc + (row.lineTotal + row.taxAmt);
                } else {
                  return acc + row.lineTotal;
                }
              }, 0.00)?.toFixed(decimalPosition)}
            </p>

          </div>
          <div className="last-total-div" style={{width:"85%",padding:"18px 32px"}}>
            <div className="sub-total">
            <h1>Sub Total</h1>
              <p>Total tax Inclusive</p>
              <p>Total tax Exclusive</p>
            <hr className='line-2' />
              <h1>Total</h1>
            </div>
            <div className="sub-total-amount">
            <h1>{formValues?.subtotal||0}</h1>
              <p>{formValues?.inclusiveTax||0}</p>
              <p>{formValues?.exclusiveTax||0}</p>
              <hr className="line-3" />
              <h1>{Number(formValues?.total)?.toFixed(decimalPosition)}</h1>
            </div>
          </div>
      </div>
      </div>
      {/* Print Content - Hidden but accessible for printing */}
      <div style={{ position: "absolute", left: "-9999px", top: 0 }}>
        <div ref={printRef} style={{ padding: "20px", fontFamily: "Arial, sans-serif", backgroundColor: "white" }}>
          {/* Header */}
          <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "20px", borderBottom: "2px solid #333", paddingBottom: "10px" }}>
            <div>
              {formValues?.companyLogo && <img src={formValues?.companyLogo} alt="Logo" style={{ maxHeight: "60px" }} />}
              <h2 style={{ margin: "5px 0" }}>{formValues?.companyName}</h2>
              <p style={{ margin: "2px 0", fontSize: "12px" }}>{formValues?.companyAddress}</p>
              <p style={{ margin: "2px 0", fontSize: "12px" }}>{formValues?.companyContact}</p>
              {formValues?.companyTRN && <p style={{ margin: "2px 0", fontSize: "12px" }}>TRN: {formValues?.companyTRN}</p>}
            </div>
            <div style={{ textAlign: "right" }}>
              <h1 style={{ margin: "0", color: "#333" }}>SALES ORDER</h1>
              <p style={{ margin: "5px 0", fontSize: "14px" }}><strong>Order No:</strong> {formValues?.name}</p>
              <p style={{ margin: "5px 0", fontSize: "14px" }}><strong>Date:</strong> {formValues?.firstDate}</p>
              <p style={{ margin: "5px 0", fontSize: "14px" }}><strong>Expiry:</strong> {formValues?.secondDate}</p>
            </div>
          </div>

          {/* Customer Info */}
          <div style={{ marginBottom: "20px", padding: "10px", backgroundColor: "#f5f5f5" }}>
            <h3 style={{ margin: "0 0 10px 0" }}>Customer Details</h3>
            <p style={{ margin: "2px 0" }}><strong>Name:</strong> {formValues?.customerName}</p>
            <p style={{ margin: "2px 0" }}><strong>Contact:</strong> {formValues?.customerContact}</p>
            <p style={{ margin: "2px 0" }}><strong>Address:</strong> {formValues?.customerAddress}</p>
            {formValues?.trn && <p style={{ margin: "2px 0" }}><strong>TRN:</strong> {formValues?.trn}</p>}
          </div>

          {/* Products Table */}
          <table style={{ width: "100%", borderCollapse: "collapse", marginBottom: "20px" }}>
            <thead>
              <tr style={{ backgroundColor: "#333", color: "white" }}>
                <th style={{ padding: "8px", border: "1px solid #333", textAlign: "center" }}>No</th>
                <th style={{ padding: "8px", border: "1px solid #333", textAlign: "left" }}>Product</th>
                <th style={{ padding: "8px", border: "1px solid #333", textAlign: "left" }}>Description</th>
                <th style={{ padding: "8px", border: "1px solid #333", textAlign: "center" }}>Qty</th>
                <th style={{ padding: "8px", border: "1px solid #333", textAlign: "center" }}>UOM</th>
                <th style={{ padding: "8px", border: "1px solid #333", textAlign: "right" }}>Rate</th>
                <th style={{ padding: "8px", border: "1px solid #333", textAlign: "right" }}>Disc%</th>
                <th style={{ padding: "8px", border: "1px solid #333", textAlign: "right" }}>Tax</th>
                <th style={{ padding: "8px", border: "1px solid #333", textAlign: "right" }}>Amount</th>
              </tr>
            </thead>
            <tbody>
              {data?.map((item, index) => (
                <tr key={index} style={{ backgroundColor: index % 2 === 0 ? "#f9f9f9" : "white" }}>
                  <td style={{ padding: "8px", border: "1px solid #ddd", textAlign: "center" }}>{index + 1}</td>
                  <td style={{ padding: "8px", border: "1px solid #ddd" }}>{item?.product}</td>
                  <td style={{ padding: "8px", border: "1px solid #ddd" }}>{item?.label}</td>
                  <td style={{ padding: "8px", border: "1px solid #ddd", textAlign: "center" }}>{item?.qty}</td>
                  <td style={{ padding: "8px", border: "1px solid #ddd", textAlign: "center" }}>{item?.uomName}</td>
                  <td style={{ padding: "8px", border: "1px solid #ddd", textAlign: "right" }}>{item?.unitPrice?.toFixed(decimalPosition)}</td>
                  <td style={{ padding: "8px", border: "1px solid #ddd", textAlign: "right" }}>{item?.discount}%</td>
                  <td style={{ padding: "8px", border: "1px solid #ddd", textAlign: "right" }}>{item?.taxAmt?.toFixed(decimalPosition)}</td>
                  <td style={{ padding: "8px", border: "1px solid #ddd", textAlign: "right" }}>{item?.lineTotal?.toFixed(decimalPosition)}</td>
                </tr>
              ))}
            </tbody>
          </table>

          {/* Totals */}
          <div style={{ display: "flex", justifyContent: "flex-end" }}>
            <div style={{ width: "300px" }}>
              <div style={{ display: "flex", justifyContent: "space-between", padding: "5px 0" }}>
                <span>Sub Total:</span>
                <span>{formValues?.subtotal}</span>
              </div>
              <div style={{ display: "flex", justifyContent: "space-between", padding: "5px 0" }}>
                <span>Tax (Inclusive):</span>
                <span>{formValues?.inclusiveTax}</span>
              </div>
              <div style={{ display: "flex", justifyContent: "space-between", padding: "5px 0" }}>
                <span>Tax (Exclusive):</span>
                <span>{formValues?.exclusiveTax}</span>
              </div>
              <div style={{ display: "flex", justifyContent: "space-between", padding: "10px 0", borderTop: "2px solid #333", fontWeight: "bold", fontSize: "16px" }}>
                <span>Total:</span>
                <span>{formValues?.total}</span>
              </div>
            </div>
          </div>

          {/* Terms */}
          {formValues?.termsAndCondition && (
            <div style={{ marginTop: "20px", paddingTop: "10px", borderTop: "1px solid #ddd" }}>
              <h4>Terms & Conditions</h4>
              <p style={{ fontSize: "12px" }}>{formValues?.termsAndCondition}</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
